import React from 'react';

import { Icon, Layout, Section, Text } from '@neptune/shared/venus-ui';

type ErrorPlaceholderProps = {
  statusPageUrl?: string;
} & Pick<React.ComponentProps<typeof Section>, 'withBorder' | 'span'>;

export const ErrorPlaceholder: React.FC<ErrorPlaceholderProps> = ({
  statusPageUrl,
  withBorder,
  ...restProps
}) => {
  return (
    <Section
      span="greedy"
      withPadding={['md', 'xl']}
      overflow="auto"
      withBorder={withBorder}
      data-role="error-placeholder"
      {...restProps}
    >
      <Layout.Column
        alignItems="center"
        span="shrink"
        spacedChildren="md"
        style={{ margin: 'auto' }}
      >
        <WarningIcon />
        <Header>Sorry, we ran into a problem loading the data for this page.</Header>
        <Info>
          Please try again in a few minutes. If this problem persists please contact your local
          Neptune administrator.
        </Info>
      </Layout.Column>
    </Section>
  );
};

const Header: React.FC = ({ children }) => (
  <Text align="center" color="text-secondary" size="md">
    {children}
  </Text>
);
const Info: React.FC = ({ children }) => <Text align="center">{children}</Text>;
const WarningIcon = () => <Icon glyph="exclamation-triangle" color="warning" size="lg" />;
